var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1437252828(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 50,
    viewBox: "0 0 280 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 50,
    rx: 25,
    fill: "#E670CC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.202 19.148C88.234 19.148 89.098 19.25 89.794 19.454C90.49 19.658 91.012 20 91.36 20.48C91.708 20.948 91.882 21.572 91.882 22.352C91.882 22.856 91.798 23.306 91.63 23.702C91.462 24.086 91.216 24.41 90.892 24.674C90.568 24.926 90.184 25.094 89.74 25.178V25.268C90.196 25.352 90.616 25.508 91 25.736C91.384 25.952 91.684 26.27 91.9 26.69C92.128 27.11 92.242 27.656 92.242 28.328C92.242 29.108 92.068 29.774 91.72 30.326C91.372 30.866 90.874 31.28 90.226 31.568C89.59 31.856 88.828 32 87.94 32H83.566V19.148H87.202ZM87.454 24.512C88.366 24.512 88.99 24.35 89.326 24.026C89.662 23.702 89.83 23.222 89.83 22.586C89.83 21.938 89.626 21.476 89.218 21.2C88.81 20.924 88.162 20.786 87.274 20.786H85.564V24.512H87.454ZM85.564 26.096V30.38H87.652C88.588 30.38 89.242 30.176 89.614 29.768C89.986 29.36 90.172 28.82 90.172 28.148C90.172 27.74 90.088 27.38 89.92 27.068C89.752 26.756 89.476 26.516 89.092 26.348C88.72 26.18 88.21 26.096 87.562 26.096H85.564ZM103.487 22.298V32H101.957L101.687 30.722H101.579C101.399 31.058 101.153 31.334 100.841 31.55C100.541 31.766 100.211 31.922 99.8505 32.018C99.4905 32.126 99.1185 32.18 98.7345 32.18C98.0265 32.18 97.4265 32.06 96.9345 31.82C96.4545 31.568 96.0825 31.184 95.8185 30.668C95.5665 30.14 95.4405 29.468 95.4405 28.652V22.298H97.4025V28.364C97.4025 29.12 97.5465 29.684 97.8345 30.056C98.1225 30.428 98.5725 30.614 99.1845 30.614C99.7845 30.614 100.253 30.482 100.589 30.218C100.937 29.954 101.183 29.57 101.327 29.066C101.471 28.55 101.543 27.932 101.543 27.212V22.298H103.487ZM105.868 22.298H107.956L109.81 27.806C109.906 28.082 109.99 28.352 110.062 28.616C110.146 28.88 110.212 29.144 110.26 29.408C110.32 29.66 110.368 29.912 110.404 30.164H110.458C110.518 29.852 110.602 29.486 110.71 29.066C110.818 28.634 110.938 28.208 111.07 27.788L112.834 22.298H114.94L111.052 33.314C110.824 33.938 110.548 34.472 110.224 34.916C109.912 35.372 109.528 35.72 109.072 35.96C108.628 36.2 108.094 36.32 107.47 36.32C107.206 36.32 106.966 36.302 106.75 36.266C106.546 36.242 106.366 36.212 106.21 36.176V34.664C106.33 34.688 106.48 34.712 106.66 34.736C106.84 34.76 107.026 34.772 107.218 34.772C107.566 34.772 107.866 34.7 108.118 34.556C108.37 34.412 108.58 34.208 108.748 33.944C108.916 33.692 109.054 33.392 109.162 33.044L109.522 32L105.868 22.298ZM126.372 19.148C127.944 19.148 129.09 19.49 129.81 20.174C130.542 20.846 130.908 21.788 130.908 23C130.908 23.54 130.824 24.056 130.656 24.548C130.5 25.04 130.236 25.484 129.864 25.88C129.504 26.264 129.018 26.57 128.406 26.798C127.794 27.014 127.044 27.122 126.156 27.122H124.896V32H122.898V19.148H126.372ZM126.264 20.786H124.896V25.484H125.94C126.588 25.484 127.128 25.406 127.56 25.25C127.992 25.082 128.316 24.824 128.532 24.476C128.76 24.116 128.874 23.648 128.874 23.072C128.874 22.304 128.664 21.734 128.244 21.362C127.824 20.978 127.164 20.786 126.264 20.786ZM138.715 22.118C138.871 22.118 139.045 22.13 139.237 22.154C139.429 22.166 139.591 22.184 139.723 22.208L139.525 23.99C139.393 23.954 139.243 23.924 139.075 23.9C138.907 23.876 138.739 23.864 138.571 23.864C138.247 23.864 137.935 23.936 137.635 24.08C137.335 24.212 137.065 24.41 136.825 24.674C136.585 24.926 136.393 25.238 136.249 25.61C136.105 25.982 136.033 26.408 136.033 26.888V32H134.089V22.298H135.619L135.871 24.026H135.979C136.159 23.678 136.381 23.36 136.645 23.072C136.921 22.784 137.233 22.556 137.581 22.388C137.929 22.208 138.307 22.118 138.715 22.118ZM145.704 22.118C146.508 22.118 147.204 22.298 147.792 22.658C148.38 23.006 148.83 23.51 149.142 24.17C149.466 24.83 149.628 25.61 149.628 26.51V27.554H143.526C143.55 28.55 143.79 29.312 144.246 29.84C144.702 30.368 145.344 30.632 146.172 30.632C146.76 30.632 147.282 30.578 147.738 30.47C148.206 30.35 148.68 30.176 149.16 29.948V31.532C148.704 31.748 148.236 31.91 147.756 32.018C147.288 32.126 146.718 32.18 146.046 32.18C145.17 32.18 144.39 31.994 143.706 31.622C143.022 31.25 142.488 30.698 142.104 29.966C141.72 29.222 141.528 28.31 141.528 27.23C141.528 26.138 141.702 25.214 142.05 24.458C142.398 23.702 142.884 23.126 143.508 22.73C144.144 22.322 144.876 22.118 145.704 22.118ZM145.704 23.594C145.092 23.594 144.6 23.816 144.228 24.26C143.856 24.704 143.64 25.334 143.58 26.15H147.702C147.702 25.646 147.63 25.202 147.486 24.818C147.342 24.434 147.12 24.134 146.82 23.918C146.532 23.702 146.16 23.594 145.704 23.594ZM163.156 22.118C164.188 22.118 164.962 22.4 165.478 22.964C166.006 23.528 166.27 24.434 166.27 25.682V32H164.326V25.934C164.326 25.19 164.188 24.632 163.912 24.26C163.648 23.876 163.234 23.684 162.67 23.684C161.89 23.684 161.332 23.954 160.996 24.494C160.672 25.022 160.51 25.79 160.51 26.798V32H158.548V25.934C158.548 25.442 158.488 25.028 158.368 24.692C158.248 24.356 158.068 24.104 157.828 23.936C157.588 23.768 157.276 23.684 156.892 23.684C156.352 23.684 155.926 23.816 155.614 24.08C155.302 24.344 155.08 24.734 154.948 25.25C154.816 25.754 154.75 26.372 154.75 27.104V32H152.806V22.298H154.336L154.624 23.594H154.714C154.906 23.258 155.134 22.982 155.398 22.766C155.674 22.55 155.986 22.388 156.334 22.28C156.682 22.172 157.042 22.118 157.414 22.118C158.098 22.118 158.674 22.25 159.142 22.514C159.61 22.766 159.958 23.156 160.186 23.684H160.312C160.6 23.144 161.002 22.748 161.518 22.496C162.034 22.244 162.58 22.118 163.156 22.118ZM171.904 22.298V32H169.942V22.298H171.904ZM170.95 18.608C171.238 18.608 171.49 18.692 171.706 18.86C171.922 19.028 172.03 19.31 172.03 19.706C172.03 20.09 171.922 20.372 171.706 20.552C171.49 20.72 171.238 20.804 170.95 20.804C170.638 20.804 170.374 20.72 170.158 20.552C169.942 20.372 169.834 20.09 169.834 19.706C169.834 19.31 169.942 19.028 170.158 18.86C170.374 18.692 170.638 18.608 170.95 18.608ZM183.61 22.298V32H182.08L181.81 30.722H181.702C181.522 31.058 181.276 31.334 180.964 31.55C180.664 31.766 180.334 31.922 179.974 32.018C179.614 32.126 179.242 32.18 178.858 32.18C178.15 32.18 177.55 32.06 177.058 31.82C176.578 31.568 176.206 31.184 175.942 30.668C175.69 30.14 175.564 29.468 175.564 28.652V22.298H177.526V28.364C177.526 29.12 177.67 29.684 177.958 30.056C178.246 30.428 178.696 30.614 179.308 30.614C179.908 30.614 180.376 30.482 180.712 30.218C181.06 29.954 181.306 29.57 181.45 29.066C181.594 28.55 181.666 27.932 181.666 27.212V22.298H183.61ZM197.691 22.118C198.723 22.118 199.497 22.4 200.013 22.964C200.541 23.528 200.805 24.434 200.805 25.682V32H198.861V25.934C198.861 25.19 198.723 24.632 198.447 24.26C198.183 23.876 197.769 23.684 197.205 23.684C196.425 23.684 195.867 23.954 195.531 24.494C195.207 25.022 195.045 25.79 195.045 26.798V32H193.083V25.934C193.083 25.442 193.023 25.028 192.903 24.692C192.783 24.356 192.603 24.104 192.363 23.936C192.123 23.768 191.811 23.684 191.427 23.684C190.887 23.684 190.461 23.816 190.149 24.08C189.837 24.344 189.615 24.734 189.483 25.25C189.351 25.754 189.285 26.372 189.285 27.104V32H187.341V22.298H188.871L189.159 23.594H189.249C189.441 23.258 189.669 22.982 189.933 22.766C190.209 22.55 190.521 22.388 190.869 22.28C191.217 22.172 191.577 22.118 191.949 22.118C192.633 22.118 193.209 22.25 193.677 22.514C194.145 22.766 194.493 23.156 194.721 23.684H194.847C195.135 23.144 195.537 22.748 196.053 22.496C196.569 22.244 197.115 22.118 197.691 22.118Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1984 23.401L61.4584 32.1114L62.0657 32.3954L62.8099 32.9634C62.8263 32.9789 62.8482 32.9943 62.8701 33.0047C63.264 33.2835 63.5212 33.7275 63.5212 34.2284C63.5212 35.0713 62.7778 35.7464 61.9125 35.7464H61.7539C61.7812 35.7464 61.8086 35.7464 61.8359 35.7412H42.0119C42.0393 35.7464 42.0667 35.7464 42.094 35.7464H41.9353C41.1136 35.7464 40.3321 35.1136 40.3321 34.2284C40.3321 33.3867 41.0489 32.7052 41.9353 32.7052H42.5099L41.3772 27.0153C41.5961 25.0016 40.9669 22.8898 39.4895 21.4441C39.8999 20.902 40.6276 20.4063 40.6276 20.4063L41.3882 20.9846L41.5086 21.0724C41.815 21.3099 42.0065 21.6765 42.0065 22.0792C42.0065 22.3838 41.9025 22.6627 41.7165 22.8898L46.1267 26.4267L51.1059 17.3961C50.5478 17.1225 50.1593 16.5597 50.1593 15.9194C50.1593 15.0004 52.2386 14.0297 52.2386 14.0297L52.9061 14.5408L52.939 14.5615L53.1195 14.7009C53.4697 15.0055 53.6886 15.4392 53.6886 15.9194C53.6886 16.5597 53.3001 17.1225 52.7365 17.3961V17.4013L57.7267 26.4267L62.1314 22.8898C61.9453 22.6627 61.8359 22.3838 61.8359 22.0792C61.8359 21.3667 63.264 20.4115 63.264 20.4115L64.1231 21.062L64.145 21.0775C64.4459 21.3202 64.632 21.6816 64.632 22.0792C64.632 22.8072 64.0082 23.401 63.2367 23.401H63.1984Z",
    fill: "#F16522"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8791 25.786L51.0785 15.2843V32.3962H53.8166L56.8791 25.786Z",
    fill: "url(#paint0_linear_601_404)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0795 15.2849L45.2837 25.7867L45.2837 25.7866L48.3415 32.3969H51.0795V15.2849Z",
    fill: "url(#paint1_linear_601_404)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2405 29.3237L53.819 32.3968H51.0806V20.9485L55.2405 29.3237Z",
    fill: "url(#paint2_linear_601_404)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0295 29.7799L53.819 32.3967H51.0806V22.3003L55.0295 29.7799Z",
    fill: "url(#paint3_linear_601_404)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9194 29.3262L51.0798 20.9485V32.3968H48.342L46.9194 29.3262Z",
    fill: "url(#paint4_linear_601_404)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0774 22.3013V32.3962H48.3379L47.1293 29.78L51.0774 22.3013Z",
    fill: "url(#paint5_linear_601_404)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6752 21.1344L56.8794 25.786L53.8169 32.3962H57.3379L60.0065 25.7004L62.6752 21.1344Z",
    fill: "url(#paint6_linear_601_404)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6752 21.1345L60.0066 25.7004L57.3379 32.3963H60.4287L62.6752 21.1344L62.6752 21.1345Z",
    fill: "url(#paint7_linear_601_404)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0065 25.7004L55.241 29.328L55.2395 29.3257L53.8169 32.3963H57.3379L60.0065 25.7004Z",
    fill: "url(#paint8_linear_601_404)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7459 26.3472L57.3367 32.396H53.8176L55.0304 29.7803L59.7459 26.3472Z",
    fill: "url(#paint9_linear_601_404)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4828 21.1344L45.2833 25.786L48.3411 32.3962H44.8201L42.1514 25.7004L39.4828 21.1344Z",
    fill: "url(#paint10_linear_601_404)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4828 21.1345L42.1515 25.7004L44.8201 32.3963H41.7293L39.4828 21.1344L39.4828 21.1345Z",
    fill: "url(#paint11_linear_601_404)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.151 25.7004L46.9165 29.328L46.9181 29.3257L48.3406 32.3963H44.8197L42.151 25.7004Z",
    fill: "url(#paint12_linear_601_404)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4125 26.3475L44.8217 32.3964H48.3408L47.1281 29.7807L42.4125 26.3475Z",
    fill: "url(#paint13_linear_601_404)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6745 33.5844C62.6745 34.4583 61.9088 35.1024 61.0659 35.1024H41.1406C40.2534 35.1024 39.5319 34.4215 39.5319 33.5844C39.5319 33.1658 39.7152 32.7863 40.005 32.5129C40.2948 32.2394 40.697 32.0664 41.1406 32.0664H61.0659C61.953 32.0664 62.6745 32.7473 62.6745 33.5844Z",
    fill: "url(#paint14_linear_601_404)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6758 33.5852C62.6758 34.4235 61.9368 35.1045 61.0658 35.1045H60.9069C61.7546 35.1045 62.4904 34.4831 62.4904 33.6802C62.4904 32.8956 61.7807 32.4608 60.9069 32.4608H41.2483C40.3745 32.4608 39.6648 32.8956 39.6648 33.6802C39.6648 34.07 39.8396 34.4298 40.1309 34.6847C40.4168 34.9396 40.8087 35.1045 41.2483 35.1045C41.1636 35.0897 40.5245 35.1911 39.9561 34.6547C39.6595 34.3799 39.4847 34.005 39.4847 33.5852C39.4847 32.7457 40.205 32.066 41.0894 32.066H61.0658C61.9502 32.066 62.6758 32.7457 62.6758 33.5852Z",
    fill: "#FFFD83"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0786 22.7212C51.2207 24.7957 51.2317 28.7773 51.0786 30.995C50.9257 28.7802 50.9364 24.7978 51.0786 22.7212Z",
    fill: "url(#paint15_radial_601_404)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0791 16.7535C51.2212 17.8218 51.2321 19.8718 51.0791 21.0134C50.9262 19.8732 50.9368 17.8228 51.0791 16.7535Z",
    fill: "url(#paint16_radial_601_404)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57.338 32.3963C57.9891 31.173 59.6359 27.0518 60.0067 25.7004C59.341 26.949 57.7022 31.0725 57.338 32.3963Z",
    fill: "url(#paint17_radial_601_404)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4237 21.5664C61.93 22.6614 60.9968 24.2663 60.2596 25.2691C60.7647 24.1468 61.7048 22.5458 62.4237 21.5664Z",
    fill: "url(#paint18_radial_601_404)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8094 32.3777C44.1584 31.1544 42.5115 27.0333 42.1407 25.6819C42.5414 26.4333 44.4452 31.054 44.8094 32.3777Z",
    fill: "url(#paint19_radial_601_404)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7241 21.5479C40.2178 22.6428 41.1511 24.2477 41.8882 25.2505C41.3831 24.1282 40.443 22.5273 39.7241 21.5479Z",
    fill: "url(#paint20_radial_601_404)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4274 32.395L62.2538 21.9994L56.5905 26.4084L51.0778 16.3639L45.5751 26.4084L39.9018 21.9994L41.7282 32.395L39.4814 21.1331L45.2832 25.7861L51.0778 15.2833L56.8796 25.7861L62.6742 21.1331L60.4274 32.395Z",
    fill: "#FEF328"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0768 16.9474C52.0507 16.9474 52.8403 16.2023 52.8403 15.2833C52.8403 14.3642 52.0507 13.6191 51.0768 13.6191C50.1028 13.6191 49.3132 14.3642 49.3132 15.2833C49.3132 16.2023 50.1028 16.9474 51.0768 16.9474Z",
    fill: "url(#paint21_linear_601_404)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0772 16.7531C51.8738 16.7531 52.5196 16.1437 52.5196 15.392C52.5196 14.6404 51.8738 14.031 51.0772 14.031C50.2806 14.031 49.6349 14.6404 49.6349 15.392C49.6349 16.1437 50.2806 16.7531 51.0772 16.7531Z",
    fill: "url(#paint22_linear_601_404)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3932 22.7603C63.1656 22.7603 63.7918 22.1694 63.7918 21.4406C63.7918 20.7117 63.1656 20.1208 62.3932 20.1208C61.6208 20.1208 60.9946 20.7117 60.9946 21.4406C60.9946 22.1694 61.6208 22.7603 62.3932 22.7603Z",
    fill: "url(#paint23_linear_601_404)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3931 22.6061C63.0247 22.6061 63.5367 22.123 63.5367 21.527C63.5367 20.931 63.0247 20.4479 62.3931 20.4479C61.7615 20.4479 61.2495 20.931 61.2495 21.527C61.2495 22.123 61.7615 22.6061 62.3931 22.6061Z",
    fill: "url(#paint24_linear_601_404)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7673 22.7603C40.5397 22.7603 41.1659 22.1694 41.1659 21.4406C41.1659 20.7117 40.5397 20.1208 39.7673 20.1208C38.9949 20.1208 38.3688 20.7117 38.3688 21.4406C38.3688 22.1694 38.9949 22.7603 39.7673 22.7603Z",
    fill: "url(#paint25_linear_601_404)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7671 22.6061C40.3987 22.6061 40.9107 22.123 40.9107 21.527C40.9107 20.931 40.3987 20.4479 39.7671 20.4479C39.1355 20.4479 38.6235 20.931 38.6235 21.527C38.6235 22.123 39.1355 22.6061 39.7671 22.6061Z",
    fill: "url(#paint26_linear_601_404)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_601_404",
    x1: 39.4777,
    y1: 23.8401,
    x2: 62.6701,
    y2: 23.8401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_601_404",
    x1: 39.4881,
    y1: 23.8407,
    x2: 62.6809,
    y2: 23.8407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.136937,
    stopColor: "#ED971A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848648,
    stopColor: "#FEF328"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_601_404",
    x1: 51.0807,
    y1: 26.6727,
    x2: 55.2408,
    y2: 26.6727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED971A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_601_404",
    x1: 58.6601,
    y1: 27.3485,
    x2: 43.5002,
    y2: 27.3485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_601_404",
    x1: 46.9198,
    y1: 26.6727,
    x2: 51.0799,
    y2: 26.6727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED971A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_601_404",
    x1: 51.0779,
    y1: 27.3486,
    x2: 47.1295,
    y2: 27.3486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.120245,
    stopColor: "#FEE825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.330162,
    stopColor: "#FCCB1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604835,
    stopColor: "#FB9D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.930612,
    stopColor: "#F85C04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942343,
    stopColor: "#F85A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_601_404",
    x1: 39.4829,
    y1: 26.7651,
    x2: 62.6753,
    y2: 26.7651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.403604,
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942342,
    stopColor: "#FCA81D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_601_404",
    x1: 45.0668,
    y1: 24.5326,
    x2: 61.6383,
    y2: 27.3139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699099,
    stopColor: "#F85A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.950781,
    stopColor: "#FB9B19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCA81D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_601_404",
    x1: 53.8172,
    y1: 29.0484,
    x2: 60.0067,
    y2: 29.0484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED971A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_601_404",
    x1: 53.8177,
    y1: 29.3718,
    x2: 59.7463,
    y2: 29.3718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20877,
    stopColor: "#FEE826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573088,
    stopColor: "#FDCB22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942342,
    stopColor: "#FCA81D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_601_404",
    x1: 62.6756,
    y1: 26.7651,
    x2: 39.4827,
    y2: 26.7651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_601_404",
    x1: 65.864,
    y1: 26.7652,
    x2: 39.4827,
    y2: 26.7652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F85A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCA81D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_601_404",
    x1: 60.9888,
    y1: 29.0484,
    x2: 42.1508,
    y2: 29.0484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED971A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_601_404",
    x1: 48.3411,
    y1: 29.3721,
    x2: 42.4125,
    y2: 29.3721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20877,
    stopColor: "#FEE826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573088,
    stopColor: "#FDCB22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942342,
    stopColor: "#FCA81D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_601_404",
    x1: 51.1037,
    y1: 32.0662,
    x2: 51.1037,
    y2: 35.1022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED971A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_601_404",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.0789 26.8749) scale(3.58173 2.92697)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1e-7,
    stopColor: "#FFFD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174803,
    stopColor: "#FFFD87",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355645,
    stopColor: "#FFFD94",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539299,
    stopColor: "#FFFEA8",
    stopOpacity: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724836,
    stopColor: "#FFFEC5",
    stopOpacity: 0.275
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910089,
    stopColor: "#FFFFEA",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_601_404",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.0794 18.9644) scale(3.58176 1.50743)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1e-7,
    stopColor: "#FFFD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174803,
    stopColor: "#FFFD87",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355645,
    stopColor: "#FFFD94",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539299,
    stopColor: "#FFFEA8",
    stopOpacity: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724836,
    stopColor: "#FFFEC5",
    stopOpacity: 0.275
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910089,
    stopColor: "#FFFFEA",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_601_404",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.6729 29.0484) scale(2.68003 2.52897)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1e-7,
    stopColor: "#FFFD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174803,
    stopColor: "#FFFD87",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355645,
    stopColor: "#FFFD94",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539299,
    stopColor: "#FFFEA8",
    stopOpacity: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724836,
    stopColor: "#FFFEC5",
    stopOpacity: 0.275
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910089,
    stopColor: "#FFFFEA",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_601_404",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.3421 23.4176) scale(1.58405 1.49477)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1e-7,
    stopColor: "#FFFD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174803,
    stopColor: "#FFFD87",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355645,
    stopColor: "#FFFD94",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539299,
    stopColor: "#FFFEA8",
    stopOpacity: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724836,
    stopColor: "#FFFEC5",
    stopOpacity: 0.275
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910089,
    stopColor: "#FFFFEA",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_601_404",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.4749 29.0296) rotate(180) scale(2.68004 2.52897)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1e-7,
    stopColor: "#FFFD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174803,
    stopColor: "#FFFD87",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355645,
    stopColor: "#FFFD94",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539299,
    stopColor: "#FFFEA8",
    stopOpacity: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724836,
    stopColor: "#FFFEC5",
    stopOpacity: 0.275
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910089,
    stopColor: "#FFFFEA",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_601_404",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.8061 23.3993) rotate(180) scale(1.58406 1.49477)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1e-7,
    stopColor: "#FFFD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174803,
    stopColor: "#FFFD87",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355645,
    stopColor: "#FFFD94",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539299,
    stopColor: "#FFFEA8",
    stopOpacity: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724836,
    stopColor: "#FFFEC5",
    stopOpacity: 0.275
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910089,
    stopColor: "#FFFFEA",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_601_404",
    x1: 49.3132,
    y1: 15.2833,
    x2: 52.8408,
    y2: 15.2833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_601_404",
    x1: 51.0778,
    y1: 14.031,
    x2: 51.0778,
    y2: 16.7536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_601_404",
    x1: 60.9952,
    y1: 21.4406,
    x2: 63.7918,
    y2: 21.4406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_601_404",
    x1: 62.3936,
    y1: 20.4479,
    x2: 62.3936,
    y2: 22.6066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_601_404",
    x1: 38.3688,
    y1: 21.4406,
    x2: 41.1659,
    y2: 21.4406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_601_404",
    x1: 39.7671,
    y1: 20.4479,
    x2: 39.7671,
    y2: 22.6066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1437252828);
export default __webpack_public_path__ + "static/media/Group 1437252828.48ee4fc7309cd46e158ce0e4a6bb10c2.svg";
export { ForwardRef as ReactComponent };